import { render, staticRenderFns } from "./user-select-box.vue?vue&type=template&id=0aaa9944&"
import script from "./user-select-box.vue?vue&type=script&lang=js&"
export * from "./user-select-box.vue?vue&type=script&lang=js&"
import style0 from "./user-select-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports